<tgt-modal [witdhModal]="'auto'">
  <main>
    @if(loading) {
      <div class="loader">
        <tgt-loader [size]="'large'"></tgt-loader>
      </div>
    } @else {

      <h3>Realizar Chamada</h3>
      <tgt-divider></tgt-divider>
      <div class="form">
        <tgt-select [error]="form.controls.turma.value === '' ? camposObrigatorio : false" label="Turma*"
        [control]="form.controls.turma" [options]="optionTurmas" (changeOption)="changeTurma($event)"></tgt-select>
        <tgt-select [error]="form.controls.materia.value === '' ? camposObrigatorio : false" label="Matéria*"
        [control]="form.controls.materia" [options]="optionMaterias" (changeValue)="changeMateria($event)"></tgt-select>
      </div>
      <div class="action">
        <tgt-button [border]="false" [color]="'primary'" [size]="'small'" [fieldButton]="'outline'" (click)="cancel()">Cancelar</tgt-button>
        <tgt-button [color]="'primary'" [fieldButton]="'field'" [size]="'small'" (click)="abrirChamada()">Continuar</tgt-button>
      </div>
    }
    </main>
</tgt-modal>
